import { getDataBase } from '../db';

export default class CategoriaConsumoDAL {
    async Get_LimitesConsumo(tnCategoria, tnConsumoHistorico, tcDataBaseAlias) {
    
      
        const loCategoriaConsumo = await this.getCategoriaConsumo(tnCategoria, tnConsumoHistorico);
        tnConsumoHistorico = Number(tnConsumoHistorico);
        // Inicializa el factor por defecto
        let lnFactor = 0.65;
    
        // Si se encuentra algún registro, se ajusta el factor y el consumo histórico
        if (loCategoriaConsumo.length > 0) {
            lnFactor = Number(loCategoriaConsumo[0].Variacion);
            if (tnConsumoHistorico == 0) {
                tnConsumoHistorico = Number(loCategoriaConsumo[0].Fin);
            }
        } else {
            // Condiciones para ajustar el factor en función del consumo histórico
            if (tnConsumoHistorico <= 39) {
                lnFactor = 0.65;
            } else if (tnConsumoHistorico >= 40 && tnConsumoHistorico <= 499) {
                lnFactor = 0.35;
            } else if (tnConsumoHistorico >= 500 && tnConsumoHistorico <= 999) {
                lnFactor = 0.20;
            } else if (tnConsumoHistorico >= 1000 && tnConsumoHistorico <= 99999) {
                lnFactor = 0.10;
            }
        }

        // Cálculo de los límites de consumo
        const lnMedia = tnConsumoHistorico;
        let lnMinimo = 0;

        if (lnFactor > 1) {
            lnMinimo = (lnMedia * lnFactor) - lnMedia;
        } else {
            lnMinimo = lnMedia - (lnMedia * lnFactor);
        }

        const lnMaximo = lnMedia + (lnMedia * lnFactor);


        // $datos = $loCategoriaConsumo[0]->Variacion;
        // $Variante = $tnConsumoHistorico * $datos;
        // $Minimo = $tnConsumoHistorico - $Variante;
        // $Maximo = $tnConsumoHistorico + $Variante;

        // Se crea el objeto de respuesta con los límites calculados
        const loCategoriaConsumoResult = {
            Maximo: lnMaximo,
            Minimo: lnMinimo
        };

        return loCategoriaConsumoResult;

    }


    // getCategoriaConsumo = async (tnCategoria, tnConsumoHistorico) => {
    //     try {
    //    
    //         const db = await getDataBase();
    //         const tx = db.transaction('CATEGORIACONSUMO', 'readonly');
    //         const store = tx.objectStore('CATEGORIACONSUMO');

    //         const index = store.index('Categoria');
    //         const range = IDBKeyRange.only(tnCategoria);
    //         const cursor = await index.openCursor(range);

    //         const resultados = [];

    //         while (cursor) {
    //             const record = cursor.value;

    //             if (record.Inicio <= tnConsumoHistorico && record.Fin >= tnConsumoHistorico) {
    //                 resultados.push(record);
    //             }

    //             cursor.continue();
    //         }

    //         await tx.done;
    //         return resultados;

    //     } catch (error) {
    //         console.error('Error al buscar categoria en getCategoriaConsumo:', error);
    //         return [];
    //     }
    // }

    getCategoriaConsumo = async (tnCategoria, tnConsumoHistorico) => {
        try {

            // const db = await getDataBase();
            // const tx = db.transaction('CATEGORIACONSUMO', 'readonly');
            // const store = tx.objectStore('CATEGORIACONSUMO');
            // const clienteData = await store.get(Number(tnCategoria));
            // await tx.done;
            // return clienteData;

            const db = await getDataBase();  // Asumimos que tienes una función para obtener la base de datos
            const tx = db.transaction('CATEGORIACONSUMO', 'readonly');
            const store = tx.objectStore('CATEGORIACONSUMO');
            
            // Buscamos todos los registros que coincidan con tnCategoria
            const index = store.index('Categoria');
            const range = IDBKeyRange.only(Number(tnCategoria));
            const registrosConCategoria = await index.getAll(range);

            const resultados = [];

            // Filtramos los registros que cumplen con las condiciones de Inicio y Fin
            registrosConCategoria.forEach(record => {
                if (record.Inicio <= tnConsumoHistorico && record.Fin >= tnConsumoHistorico) {
                    resultados.push(record);
                }
            });

            await tx.done;
            return resultados;
        } catch (error) {
            console.error('Error al buscar categoria en getCategoriaConsumo:', error);
            return [];
        }
    };
    

    getCategoriaConsumoInicio = async (tnCategoria) => {
        try {
            const db = await getDataBase();
            const tx = db.transaction('CATEGORIACONSUMO', 'readonly');
            const store = tx.objectStore('CATEGORIACONSUMO');

            const index = store.index('Categoria'); // Suponiendo que tienes un índice sobre 'Categoria'
            const range = IDBKeyRange.only(Number(tnCategoria));
            const registrosConCategoria = await index.getAll(range);
            
            const resultados = [];

            // Filtramos los registros que cumplen con las condiciones de Inicio y Fin
            registrosConCategoria.forEach(record => {
                if (record.Inicio == '0') {
                    resultados.push(record);
                }
            });

            await tx.done;
            return resultados;

            
        } catch (error) {
            console.error('Error al buscar categoria en getCategoriaConsumoInicio:', error);
            return [];
        
        }
    }
        
    





    //---- CategoriaConsumoDal.js
    //
    // static async Get_LimitesConsumo(tnCategoria, tnConsumoHistorico, tcDataBaseAlias) {
    //     let loCategoriaConsumo = [];
    //     //consulta a la base de datos de la tabla CategoriaConsumo

    //     loCategoriaConsumo.push({
    //         'Variacion': 0,
    //         'Fin': 0
    //     });

    //     let lnFactor = 0.65;

    //     if (loCategoriaConsumo.length > 0) {
    //     lnFactor = loCategoriaConsumo[0].Variacion;
    //     if (tnConsumoHistorico == 0) {
    //         tnConsumoHistorico = loCategoriaConsumo[0].Fin;
    //     }
    //     } else {
    //     if (tnConsumoHistorico <= 39) {
    //         lnFactor = 0.65;
    //     } else if (tnConsumoHistorico >= 40 && tnConsumoHistorico <= 499) {
    //         lnFactor = 0.35;
    //     } else if (tnConsumoHistorico >= 500 && tnConsumoHistorico <= 999) {
    //         lnFactor = 0.20;
    //     } else if (tnConsumoHistorico >= 1000 && tnConsumoHistorico <= 99999) {
    //         lnFactor = 0.10;
    //     }
    //     }

    //     const lnMedia = tnConsumoHistorico;
    //     let lnMinimo = 0;

    //     if (lnFactor > 1) {
    //     lnMinimo = (lnMedia * lnFactor) - lnMedia;
    //     } else {
    //     lnMinimo = lnMedia - (lnMedia * lnFactor);
    //     }

    //     const lnMaximo = lnMedia + (lnMedia * lnFactor);

    //     loCategoriaConsumo = { Maximo: lnMaximo, Minimo: lnMinimo };

    //     return loCategoriaConsumo;
    // }




}